import { render, staticRenderFns } from "./ticketshoriz.vue?vue&type=template&id=30349907&"
import script from "./ticketshoriz.vue?vue&type=script&lang=js&"
export * from "./ticketshoriz.vue?vue&type=script&lang=js&"
import style0 from "./ticketshoriz.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports